import { Drawer } from "@mantine/core";

export const DrawerStack = Drawer.Stack;

export { Drawer } from "./drawer";
export { DrawerHeader } from "./drawer-header";
